import { a as __makeTemplateObject, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import ReactDom from 'react-dom';
import Transition from 'react-transition-group/Transition';
import styled from 'styled-components';

var Button = styled.button.attrs({
    type: 'button',
})(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  background: none;\n  border: 0;\n  cursor: pointer;\n  margin: 0;\n  outline: none;\n  padding: 0;\n  position: absolute;\n  right: 8px;\n  top: 7px;\n\n  &:active {\n    outline: none;\n  }\n"], ["\n  background: none;\n  border: 0;\n  cursor: pointer;\n  margin: 0;\n  outline: none;\n  padding: 0;\n  position: absolute;\n  right: 8px;\n  top: 7px;\n\n  &:active {\n    outline: none;\n  }\n"])));
Button.displayName = 'Button';
var CloseButton = function (props) { return (jsx(Button, __assign({ onClick: props.onClick }, { children: jsx("svg", __assign({ height: 15, width: 15 }, { children: jsx("g", __assign({ fill: "none", fillRule: "evenodd", stroke: props.themeValues.borderColor, strokeLinecap: "square" }, { children: jsx("path", { d: "M.5.5l13.51 13.51M14.5.5L.99 14.01" }, void 0) }), void 0) }), void 0) }), void 0)); };
var templateObject_1$2;

var CONTAINER_MARGIN_HORIZONTAL = 5;
var CONTAINER_OFFSET_VERTICAL = 3;
var CONTAINER_OFFSET_HORIZONTAL = 34;

function getContainerIsCenterable(containerRect, targetRect) {
    var containerWidth = containerRect.width;
    var containerLeftAnchoredCenter = (window.innerWidth - containerWidth) / 2;
    var targetLeftRelativeToContainer = targetRect.left - containerLeftAnchoredCenter - CONTAINER_OFFSET_HORIZONTAL;
    var targetRightRelativeToContainer = targetRect.right -
        containerLeftAnchoredCenter +
        CONTAINER_OFFSET_HORIZONTAL;
    return (targetLeftRelativeToContainer > 0 &&
        targetRightRelativeToContainer < containerWidth);
}
/**
 * Calculates the Container's `left` position from any value of `anchor`
 */
function getContainerLeft(anchor, containerRef, targetRef) {
    if (!targetRef || !containerRef) {
        return null;
    }
    var containerRect = containerRef.getBoundingClientRect();
    var targetRect = targetRef.getBoundingClientRect();
    var containerLeftAnchoredCenter = Math.max(0, Math.floor((window.innerWidth - containerRect.width) / 2 -
        CONTAINER_MARGIN_HORIZONTAL));
    var containerLeftAnchoredLeft = Math.max(0, Math.floor(targetRect.left -
        CONTAINER_OFFSET_HORIZONTAL -
        CONTAINER_MARGIN_HORIZONTAL));
    var containerRight = getContainerRight(targetRef) || 0;
    var containerLeftAnchoredRight = window.innerWidth -
        containerRight -
        containerRect.width -
        CONTAINER_MARGIN_HORIZONTAL * 2;
    switch (anchor) {
        case 'left':
            return containerLeftAnchoredLeft;
        case 'right':
            return containerLeftAnchoredRight;
        case 'auto':
        default: {
            var isCenterable = getContainerIsCenterable(containerRect, targetRect);
            if (isCenterable) {
                return containerLeftAnchoredCenter;
            }
            else if (targetRect.left < window.innerWidth / 2) {
                return containerLeftAnchoredLeft;
            }
            else {
                return containerLeftAnchoredRight;
            }
        }
    }
}
/**
 * Calculates the Container's `right` position when `anchor` is `right`
 */
function getContainerRight(targetRef) {
    if (!targetRef) {
        return null;
    }
    var targetRect = targetRef.getBoundingClientRect();
    var containerRightAnchoredRight = Math.max(0, Math.floor(window.innerWidth -
        targetRect.right -
        CONTAINER_OFFSET_HORIZONTAL -
        CONTAINER_MARGIN_HORIZONTAL));
    return containerRightAnchoredRight;
}

var Container = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  border-radius: 8px;\n  box-shadow: 1px 1px 5px 0 rgba(74, 74, 74, 0.4);\n  left: 0;\n  margin: 0 ", "px;\n  position: absolute;\n  /**\n   * Prevents issue on Windows where the container is initially rendered below\n   * the body, which makes a scroll bar appear during rendering, throwing off\n   * initial position\n   */\n  top: 0;\n  width: fit-content;\n  /*\n   * This can be increased if it needs to be. It's only 2 to get it above\n   * .CodeMirror-line in the style guide\n   */\n  z-index: 2;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  border-radius: 8px;\n  box-shadow: 1px 1px 5px 0 rgba(74, 74, 74, 0.4);\n  left: 0;\n  margin: 0 ", "px;\n  position: absolute;\n  /**\n   * Prevents issue on Windows where the container is initially rendered below\n   * the body, which makes a scroll bar appear during rendering, throwing off\n   * initial position\n   */\n  top: 0;\n  width: fit-content;\n  /*\n   * This can be increased if it needs to be. It's only 2 to get it above\n   * .CodeMirror-line in the style guide\n   */\n  z-index: 2;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), CONTAINER_MARGIN_HORIZONTAL, function (_a) {
    var hasCloseButton = _a.hasCloseButton, themeValues = _a.themeValues;
    return "\n    background: " + themeValues.backgroundColor + ";\n    border: 1px solid " + themeValues.borderColor + ";\n    padding: " + (hasCloseButton ? '15px 30px 15px 15px' : '15px') + ";\n    transition: opacity " + themeValues.transitionDuration + " ease,\n      transform " + themeValues.transitionDuration + " ease;\n  ";
}, function (_a) {
    var position = _a.position, transitionStatus = _a.transitionStatus;
    switch (transitionStatus) {
        case 'entered':
        case 'entering':
            return "\n          opacity: 1;\n          transform: translateY(0);\n        ";
        case 'exiting':
        case 'exited':
        case 'unmounted':
        default: {
            var offset = position === 'bottom' ? -15 : 15;
            return "\n          opacity: 0;\n          transform: translateY(" + offset + "px);\n        ";
        }
    }
}, function (_a) {
    var containerRef = _a.containerRef, position = _a.position, targetRef = _a.targetRef;
    if (containerRef && targetRef) {
        var containerRect = containerRef.getBoundingClientRect();
        var targetRect = targetRef.getBoundingClientRect();
        switch (position) {
            case 'bottom':
                return "\n            top: " + Math.floor(targetRect.bottom +
                    window.pageYOffset +
                    CONTAINER_OFFSET_VERTICAL) + "px;\n          ";
            case 'top': {
                return "\n            top: " + Math.floor(targetRect.top -
                    containerRect.height -
                    CONTAINER_OFFSET_VERTICAL +
                    window.pageYOffset) + "px;\n          ";
            }
        }
    }
}, function (_a) {
    var anchor = _a.anchor, containerRef = _a.containerRef, targetRef = _a.targetRef;
    switch (anchor) {
        case 'right': {
            var right = getContainerRight(targetRef);
            if (right !== null) {
                return "\n            left: auto;\n            right: " + right + "px;\n          ";
            }
        }
        case 'auto':
        case 'left':
        default: {
            var left = getContainerLeft(anchor, containerRef, targetRef);
            if (left !== null) {
                return "\n            left: " + left + "px;\n          ";
            }
        }
    }
});
Container.displayName = 'Container';
var templateObject_1$1;

var POINTER_HEIGHT = 11;
var PointerSvg = styled.svg.attrs(function () { return ({
    height: POINTER_HEIGHT,
    width: 26,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  right: 30px;\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  right: 30px;\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var position = _a.position;
    switch (position) {
        case 'top':
            return "\n          bottom: -" + POINTER_HEIGHT + "px;\n          transform: rotate(180deg);\n        ";
        case 'bottom':
        default:
            return "\n          top: -" + POINTER_HEIGHT + "px;\n        ";
    }
}, function (_a) {
    var anchor = _a.anchor, containerRef = _a.containerRef, targetRef = _a.targetRef, width = _a.width;
    if (containerRef && targetRef) {
        switch (anchor) {
            case 'left': {
                return "\n            left: " + CONTAINER_OFFSET_HORIZONTAL + "px;\n          ";
            }
            case 'right': {
                return "\n            right: " + CONTAINER_OFFSET_HORIZONTAL + "px;\n          ";
            }
            case 'auto':
            default: {
                var containerLeft = getContainerLeft(anchor, containerRef, targetRef);
                var targetRect = targetRef.getBoundingClientRect();
                if (containerLeft !== null) {
                    var pointerLeft = targetRect.left -
                        containerLeft +
                        (targetRect.width / 2 - width / 2) -
                        CONTAINER_MARGIN_HORIZONTAL;
                    return "\n              left: " + pointerLeft + "px;\n            ";
                }
            }
        }
    }
});
PointerSvg.displayName = 'PointerSvg';
var Pointer = function (props) { return (jsx(PointerSvg, __assign({}, props, { children: jsxs("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [jsx("path", { d: "M0 10L13 0h0l13 10", stroke: props.themeValues.borderColor }, void 0), jsx("path", { d: "M0 11L13 1l13 10", fill: props.themeValues.backgroundColor }, void 0)] }), void 0) }), void 0)); };
var templateObject_1;

var tooltipDefaultThemeValues = {
    backgroundColor: '#fff',
    borderColor: '#4C6B9A',
    transitionDuration: '250ms',
};
/**
 * A tooltip that attaches to the passed `targetRef` prop. Create a local
 * `isVisible` state variable and pass it as a prop, then call its setter when
 * the `onClose` handler is called.
 */
var Tooltip = function (_a) {
    var _b = _a.anchor, anchor = _b === void 0 ? 'auto' : _b, children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.hasCloseButton, hasCloseButton = _d === void 0 ? false : _d, onClose = _a.onClose, isVisible = _a.isVisible, _e = _a.position, position = _e === void 0 ? 'bottom' : _e, _f = _a.shouldCloseOnBlur, shouldCloseOnBlur = _f === void 0 ? true : _f, targetRef = _a.targetRef, _g = _a.themeValues, themeValuesFromProps = _g === void 0 ? {} : _g, timeUntilClose = _a.timeUntilClose;
    var containerRef = useRef(null);
    var themeValues = __assign(__assign({}, tooltipDefaultThemeValues), themeValuesFromProps);
    var handleBlur = function () {
        if (shouldCloseOnBlur) {
            onClose(null);
        }
    };
    var handleClose = function () {
        onClose(null);
    };
    var handleContainerMouseUp = function (event) {
        // Prevents mouseup events on the container from propogating up to the
        // window and causing the Tooltip to close
        event.stopPropagation();
    };
    var handleEntered = function () {
        window.addEventListener('mouseup', handleBlur);
    };
    var handleExited = function () {
        window.removeEventListener('mouseup', handleBlur);
    };
    useEffect(function () {
        var timeUntilCloseTimeoutId = 0;
        if (isVisible && timeUntilClose) {
            timeUntilCloseTimeoutId = window.setTimeout(function () { return onClose(null); }, timeUntilClose);
        }
        return function () {
            window.clearTimeout(timeUntilCloseTimeoutId);
        };
    }, [isVisible, onClose, timeUntilClose]);
    return ReactDom.createPortal(jsx(Transition, __assign({ in: isVisible, mountOnEnter: true, onEntered: handleEntered, onExited: handleExited, timeout: parseInt(themeValues.transitionDuration, 10), unmountOnExit: true }, { children: function (transitionStatus) { return (jsxs(Container, __assign({ anchor: anchor, className: className, containerRef: containerRef.current, hasCloseButton: hasCloseButton, onMouseUp: handleContainerMouseUp, position: position, ref: containerRef, targetRef: targetRef, themeValues: themeValues, transitionStatus: transitionStatus }, { children: [jsx(Pointer, { anchor: anchor, containerRef: containerRef.current, position: position, targetRef: targetRef, themeValues: themeValues }, void 0), hasCloseButton && (jsx(CloseButton, { onClick: handleClose, themeValues: themeValues }, void 0)), children] }), void 0)); } }), void 0), document.body);
};

export { Tooltip as T, tooltipDefaultThemeValues as t };
